import { motion } from "framer-motion";

import Block3Columns from "../../components/Block3Columns";
import ImageContainer from "../../components/ImageContainer";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import MasonryGallery from "../../components/MasonryGallery";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import {
  BookOpen,
  Users,
  Globe,
  Lightbulb,
  Award,
  Search,
  TrendingUp,
  Heart,
  Download,
  Video,
  FileText,
  HelpCircle,
  Mail,
  Phone,
  ArrowRight,
  ChevronRight,
  MapPin,
  PartyPopper,
  Shirt,
  QrCode,
  GraduationCap,
} from "lucide-react";

const url =
  "https://be-portales.utpl.edu.ec/jsonapi/node/template_home/2347fea9-3e00-49c1-8c9f-6e5e9985b2b1" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

function PresencialResultados() {
  const DataDisplay = ({ data }) => (
    <div>
         <div className="margin pt-10 text-center"
        dangerouslySetInnerHTML={{
          __html: data.texto_portada,
        }}
      />
           <div
        dangerouslySetInnerHTML={{
          __html: data.bloque1,
        }}
      />

      <div className="pt-10 margin"
        dangerouslySetInnerHTML={{
          __html: data.bloque2,
        }}
      />

 
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default PresencialResultados;
